import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Table } from '@octano/global-ui';

import { TranslationsKeys } from '../../../../locales/translations';
import { HomologationRequestListItem } from '../types';
import useColumns from '../hooks/useColumns';
import { useAuthorizationDataLoader } from './AuthorizationDataLoader';
import ObservationModal from './ObservationModal';

export default function AuthorizationTable() {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_AUTHORIZATION);
  const { data, updateQuery, query } = useAuthorizationDataLoader();
  const history = useHistory();

  const [observationModal, setObservationModal] = useState<{
    isOpen: boolean;
    observation: string | null;
  }>({ isOpen: false, observation: null });

  const onViewDetail = useCallback(
    (row: HomologationRequestListItem) => {
      history.push(`/authorization-requests/${row.responseId}`);
    },
    [history],
  );

  const onShowObservation = useCallback((row: HomologationRequestListItem) => {
    setObservationModal({ isOpen: true, observation: row.observation });
  }, []);

  const columns = useColumns({ onViewDetail, onShowObservation });

  return (
    <>
      <Table
        data={data?.data ?? []}
        columns={columns}
        noResultsText={
          <p className="text-muted text-center py-4">{t('table.noResults')}</p>
        }
        pagination={{
          totalItems: data?.total ?? 0,
          onChangePage: (page) => updateQuery((prev) => ({ ...prev, page })),
          itemsPerPage: 10,
          totalPages: data?.total_pages ?? 0,
          currentPage: query.page,
        }}
      />
      <ObservationModal
        isOpen={observationModal.isOpen}
        toggle={() => setObservationModal({ isOpen: false, observation: null })}
        observation={observationModal.observation}
      />
    </>
  );
}
